import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { getApiBaseUrl } from '../config';
import InvoiceService from './InvoiceService';

class StripeService {
    constructor(stripe, elements, formData, getTotalCartAmount, clearCart, onContinue, generatePDF, cartItems, setLoading, updateStock) {
        this.stripe = stripe;
        this.elements = elements;
        this.formData = formData;
        this.getTotalCartAmount = getTotalCartAmount;
        this.clearCart = clearCart;
        this.onContinue = onContinue;
        this.generatePDF = generatePDF;
        this.cartItems = cartItems;
        this.setLoading = setLoading; 
        this.updateStock = updateStock;
    }

    async handleStripePayment() {
        if (!this.stripe || !this.elements) return;

        const cardNumber = this.elements.getElement(CardNumberElement);
        const { error, paymentMethod } = await this.stripe.createPaymentMethod({
            type: 'card',
            card: cardNumber,
            billing_details: {
                name: this.formData.name,
                email: this.formData.email,
            },
        });

        if (error) {
            console.error('Payment error:', error);
            this.setLoading(false);
            // Display user-friendly error messages
            if (error.type === 'card_error' || error.type === 'validation_error') {
                alert('Invalid card details. Please check your card and try again.');
            } else {
                alert('Something went wrong. Please try again.');
            }
            return;
        }

        const totalPrice = this.getTotalCartAmount() + (this.formData.shippingFee || 0);

        // Ensure the amount is an integer by rounding it
        const amountInCents = Math.round(totalPrice * 100);

        const response = await fetch(`${getApiBaseUrl()}/create-payment-stripe`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: amountInCents * 100 }),
        });

        const { clientSecret } = await response.json();

        const result = await this.stripe.confirmCardPayment(clientSecret, {
            payment_method: paymentMethod.id,
        });

        if (result.error) {
            console.error('Payment error:', result.error);
            this.setLoading(false); 
            alert('Payment failed during confirmation. Please try again.');
        } else if (result.paymentIntent.status === 'succeeded') {
            
            // Step 1: Generate PDF invoice after successful payment
           this.generatePDF({
                formData: this.formData,
                totalPrice,
                shippingFee: this.formData.shippingFee || 0,
                cartItems: this.cartItems,  // Ensure cartItems is not undefined
            });

            // Step 2: Create the order with InvoiceService
            const orderData = {
                customerName: `${this.formData.name} ${this.formData.lastName}`,
                email: this.formData.email,
                address: this.formData.address,
                city: this.formData.city,
                postalCode: this.formData.postalCode,
                products: this.cartItems, // Add cart items to the order
                shippingFee: this.formData.shippingFee,
                shippingMethod: this.formData.shippingMethod || 'standard',
                totalAmount: totalPrice,
                status: 'pending',  // Mark the status as 'paid'
            };

            // Call createOrder method from InvoiceService to save the order
            InvoiceService.createOrder({ orderData });
            await this.updateStock(this.cartItems);
            
            this.clearCart();
            this.onContinue();
            this.setLoading(false); 
        }
    }
}

export default StripeService;
